import { apiSlice as api } from '../../../../apiSlice';
export const addTagTypes = [
  'AlarmGroups',
  'Alarms',
  'AlarmTypes',
  'Units',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      alarmGroupsGetCollectionAsyncByqueryOptions: build.query<
        AlarmGroupsGetCollectionAsyncByqueryOptionsApiResponse,
        AlarmGroupsGetCollectionAsyncByqueryOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/AlarmGroups`,
          params: {
            orderby: queryArg.orderby,
            orderbydesc: queryArg.orderbydesc,
            'Account.AccountId': queryArg['Account.AccountId'],
            top: queryArg.top,
            skip: queryArg.skip,
          },
        }),
        providesTags: ['AlarmGroups'],
      }),
      alarmGroupsPostBynewAlarmGroup: build.mutation<
        AlarmGroupsPostBynewAlarmGroupApiResponse,
        AlarmGroupsPostBynewAlarmGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/AlarmGroups`,
          method: 'POST',
          body: queryArg.createAlarmGroupDto,
        }),
        invalidatesTags: ['AlarmGroups'],
      }),
      alarmGroupsGetAsyncByid: build.query<
        AlarmGroupsGetAsyncByidApiResponse,
        AlarmGroupsGetAsyncByidApiArg
      >({
        query: (queryArg) => ({ url: `/AlarmGroups/${queryArg.id}` }),
        providesTags: ['AlarmGroups'],
      }),
      alarmGroupsDeleteAsyncByid: build.mutation<
        AlarmGroupsDeleteAsyncByidApiResponse,
        AlarmGroupsDeleteAsyncByidApiArg
      >({
        query: (queryArg) => ({
          url: `/AlarmGroups/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['AlarmGroups'],
      }),
      alarmGroupsPatchAsyncByidalarmGroup: build.mutation<
        AlarmGroupsPatchAsyncByidalarmGroupApiResponse,
        AlarmGroupsPatchAsyncByidalarmGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/AlarmGroups/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.editAlarmGroupDto,
        }),
        invalidatesTags: ['AlarmGroups'],
      }),
      alarmsGetCollectionAsyncByqueryOptions: build.query<
        AlarmsGetCollectionAsyncByqueryOptionsApiResponse,
        AlarmsGetCollectionAsyncByqueryOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/Alarms`,
          params: {
            orderby: queryArg.orderby,
            orderbydesc: queryArg.orderbydesc,
            'Account.AccountId': queryArg['Account.AccountId'],
            State: queryArg.state,
            top: queryArg.top,
            skip: queryArg.skip,
          },
        }),
        providesTags: ['Alarms'],
      }),
      alarmsGetAsyncByid: build.query<
        AlarmsGetAsyncByidApiResponse,
        AlarmsGetAsyncByidApiArg
      >({
        query: (queryArg) => ({ url: `/Alarms/${queryArg.id}` }),
        providesTags: ['Alarms'],
      }),
      alarmsPatchAsyncByidalarm: build.mutation<
        AlarmsPatchAsyncByidalarmApiResponse,
        AlarmsPatchAsyncByidalarmApiArg
      >({
        query: (queryArg) => ({
          url: `/Alarms/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.editAlarmDto,
        }),
        invalidatesTags: ['Alarms'],
      }),
      alarmsGetFeedAsyncByqueryOptions: build.query<
        AlarmsGetFeedAsyncByqueryOptionsApiResponse,
        AlarmsGetFeedAsyncByqueryOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/Alarms/Feed`,
          params: {
            orderby: queryArg.orderby,
            orderbydesc: queryArg.orderbydesc,
            'Account.AccountId': queryArg['Account.AccountId'],
            Created: queryArg.created,
            top: queryArg.top,
            skip: queryArg.skip,
          },
        }),
        providesTags: ['Alarms'],
      }),
      alarmTypesGetCollectionAsyncByqueryOptions: build.query<
        AlarmTypesGetCollectionAsyncByqueryOptionsApiResponse,
        AlarmTypesGetCollectionAsyncByqueryOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/AlarmTypes`,
          params: {
            orderby: queryArg.orderby,
            orderbydesc: queryArg.orderbydesc,
            top: queryArg.top,
            skip: queryArg.skip,
          },
        }),
        providesTags: ['AlarmTypes'],
      }),
      alarmTypesGetAsyncByid: build.query<
        AlarmTypesGetAsyncByidApiResponse,
        AlarmTypesGetAsyncByidApiArg
      >({
        query: (queryArg) => ({ url: `/AlarmTypes/${queryArg.id}` }),
        providesTags: ['AlarmTypes'],
      }),
      unitsResetAlarmByidalarmTypeId: build.mutation<
        UnitsResetAlarmByidalarmTypeIdApiResponse,
        UnitsResetAlarmByidalarmTypeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Units/${queryArg.id}/ResetAlarm/${queryArg.alarmTypeId}`,
          method: 'PATCH',
        }),
        invalidatesTags: ['Units'],
      }),
      unitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataType:
        build.mutation<
          UnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeApiResponse,
          UnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeApiArg
        >({
          query: (queryArg) => ({
            url: `/Units/${queryArg.unitId}/AlarmConfiguration/${queryArg.key}/${queryArg.unitTypeInputId}/${queryArg.dataType}`,
            method: 'PUT',
            params: {
              value: queryArg.value,
            },
          }),
          invalidatesTags: ['Units'],
        }),
      unitsGetAlarmConfigurationAsyncByid: build.query<
        UnitsGetAlarmConfigurationAsyncByidApiResponse,
        UnitsGetAlarmConfigurationAsyncByidApiArg
      >({
        query: (queryArg) => ({
          url: `/Units/${queryArg.id}/AlarmConfiguration`,
        }),
        providesTags: ['Units'],
      }),
      unitsGetAllAlarmConfigurationsAsync: build.query<
        UnitsGetAllAlarmConfigurationsAsyncApiResponse,
        UnitsGetAllAlarmConfigurationsAsyncApiArg
      >({
        query: () => ({ url: `/Units/AlarmConfiguration` }),
        providesTags: ['Units'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcOpenApi };
export type AlarmGroupsGetCollectionAsyncByqueryOptionsApiResponse =
  /** status 200 AlarmGroup entities response */ ReadAlarmGroupDto[];
export type AlarmGroupsGetCollectionAsyncByqueryOptionsApiArg = {
  /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>AlarmGroupId</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderby?: string;
  /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>AlarmGroupId</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderbydesc?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by Account.AccountId using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(int)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(3001)</code></pre></div> */
  'Account.AccountId'?: string;
  /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
  top?: number;
  /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
  skip?: number;
};
export type AlarmGroupsPostBynewAlarmGroupApiResponse =
  /** status 201 Created */ object;
export type AlarmGroupsPostBynewAlarmGroupApiArg = {
  /** The entity to create */
  createAlarmGroupDto: CreateAlarmGroupDto;
};
export type AlarmGroupsGetAsyncByidApiResponse =
  /** status 200 AlarmGroup entity response */ ReadAlarmGroupDto;
export type AlarmGroupsGetAsyncByidApiArg = {
  /** Id of entity to retrieve */
  id: number;
};
export type AlarmGroupsDeleteAsyncByidApiResponse =
  /** status 204 No content */ object;
export type AlarmGroupsDeleteAsyncByidApiArg = {
  /** Id of entity to delete */
  id: number;
};
export type AlarmGroupsPatchAsyncByidalarmGroupApiResponse =
  /** status 204 No content */ object;
export type AlarmGroupsPatchAsyncByidalarmGroupApiArg = {
  /** The id of the AlarmGroup */
  id: number;
  /** The changes to apply */
  editAlarmGroupDto: EditAlarmGroupDto;
};
export type AlarmsGetCollectionAsyncByqueryOptionsApiResponse =
  /** status 200 Alarm entities response */ ReadAlarmDto[];
export type AlarmsGetCollectionAsyncByqueryOptionsApiArg = {
  /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>Created</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderby?: string;
  /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>Created</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderbydesc?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by Account.AccountId using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(int)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(3001)</code></pre></div> */
  'Account.AccountId'?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by State using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(alarmstate)</code></pre></div><p>state = ['Unresolved', 'Reject', 'Solved', 'Reset', 'AutoResolved', 'FalseAlarm', 'None']</p><p>Examples:</p><div><pre>Equal to:
    <code>eq(Unresolved)</code></pre></div> */
  state?: string;
  /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
  top?: number;
  /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
  skip?: number;
};
export type AlarmsGetAsyncByidApiResponse =
  /** status 200 Alarm entity response */ ReadAlarmDto;
export type AlarmsGetAsyncByidApiArg = {
  /** The id of the alarm */
  id: number;
};
export type AlarmsPatchAsyncByidalarmApiResponse =
  /** status 204 No content */ object;
export type AlarmsPatchAsyncByidalarmApiArg = {
  /** The id of the alarm */
  id: number;
  /** The changes to apply */
  editAlarmDto: EditAlarmDto;
};
export type AlarmsGetFeedAsyncByqueryOptionsApiResponse =
  /** status 200 Alarm entities response */ ReadAlarmDto[];
export type AlarmsGetFeedAsyncByqueryOptionsApiArg = {
  /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>Created</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderby?: string;
  /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>Created</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderbydesc?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by Account.AccountId using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(int)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(3001)</code></pre></div> */
  'Account.AccountId'?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by Created using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(datetime)</code>
    Greater than or equal:
    <code>ge(datetime)</code>
    Greater than:
    <code>gt(datetime)</code>
    Less than or equal:
    <code>le(datetime)</code>
    Less than:
    <code>lt(datetime)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(2021-01-01T16:00:00.0000000+02:00)</code>
    Greater than or equal:
    <code>ge(2021-01-01T16:00:00.0000000+02:00)</code>
    Greater than:
    <code>gt(2021-01-01T16:00:00.0000000+02:00)</code>
    Less than or equal:
    <code>le(2021-01-02T16:00:00.0000000+02:00)</code>
    Less than:
    <code>lt(2021-01-02T16:00:00.0000000+02:00)</code></pre></div> */
  created?: string;
  /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
  top?: number;
  /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
  skip?: number;
};
export type AlarmTypesGetCollectionAsyncByqueryOptionsApiResponse =
  /** status 200 AlarmType entities response */ ReadAlarmTypeDto[];
export type AlarmTypesGetCollectionAsyncByqueryOptionsApiArg = {
  /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>AlarmTypeId</strong> (default), <strong>Name</strong>, <strong>Description</strong>.</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderby?: string;
  /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>AlarmTypeId</strong> (default), <strong>Name</strong>, <strong>Description</strong>.</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderbydesc?: string;
  /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
  top?: number;
  /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
  skip?: number;
};
export type AlarmTypesGetAsyncByidApiResponse =
  /** status 200 AlarmType entities response */ ReadAlarmTypeDto;
export type AlarmTypesGetAsyncByidApiArg = {
  /** Id of entity to retrieve */
  id: number;
};
export type UnitsResetAlarmByidalarmTypeIdApiResponse =
  /** status 204 No content */ object;
export type UnitsResetAlarmByidalarmTypeIdApiArg = {
  /** Id of the unit */
  id: number;
  /** Id of the alarm type */
  alarmTypeId: number;
};
export type UnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeApiResponse =
  /** status 204 No content */ object;
export type UnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeApiArg =
  {
    /** The id of the Unit */
    unitId: number;
    /** The unitTypeInputIdt */
    unitTypeInputId: number;
    /** Configuration key */
    key: string;
    /** Configuration value */
    value?: string;
    /** Configuration dataType (optional) */
    dataType: string;
  };
export type UnitsGetAlarmConfigurationAsyncByidApiResponse =
  /** status 200 Alarm configurations response */ ReadAlarmTypeConfigurationDto[];
export type UnitsGetAlarmConfigurationAsyncByidApiArg = {
  /** The id of the Unit */
  id: number;
};
export type UnitsGetAllAlarmConfigurationsAsyncApiResponse =
  /** status 200 AlarmConfigurations entities response */ ReadAlarmTypeConfigurationDto[];
export type UnitsGetAllAlarmConfigurationsAsyncApiArg = void;
export type AccountNoRefsDto = {
  AccountId: number;
  Name: string;
  Address: string;
  BillingAddress?: string;
};
export type UserNoRefsDto = {
  UserId: number;
  Email: string;
  Created: string;
  Active: boolean;
  TimeZone?: string;
};
export type ReadAlarmSubscriptionDto = {
  AlarmSubscriptionId: number;
  Subscribed: string;
  User: UserNoRefsDto;
  FeedSeverity?:
    | 'Information'
    | 'Trivial'
    | 'Minor'
    | 'Medium'
    | 'Major'
    | 'Critical';
  EmailSeverity?:
    | 'Information'
    | 'Trivial'
    | 'Minor'
    | 'Medium'
    | 'Major'
    | 'Critical';
};
export type AlarmTypeNoRefsDto = {
  AlarmTypeId: number;
  Name: string;
  Description: string;
};
export type ReadAlarmInclusionDto = {
  AlarmInclusionId: number;
  Included: string;
  AlarmType: AlarmTypeNoRefsDto;
};
export type ReadAlarmGroupDto = {
  AlarmGroupId: number;
  Name: string;
  Account: AccountNoRefsDto;
  AlarmSubscriptions?: ReadAlarmSubscriptionDto[];
  AlarmInclusions?: ReadAlarmInclusionDto[];
};
export type ErrorResult = {
  Code: string;
  Message: string;
};
export type BadRequestError = {
  Code: string;
  Message: string;
};
export type PropertyValueError = {
  Property: string;
  Code: string;
  Message: string;
};
export type ArrayProperty = {
  Property?: ArrayProperty;
  Name: string;
  Index?: number;
};
export type ArrayPropertyValueError = {
  Property: ArrayProperty;
  Code: string;
  Message: string;
};
export type ErrorDetailsResult2 = ErrorResult & {
  BadRequestErrors?: BadRequestError[];
  PropertyValueErrors?: PropertyValueError[];
  ArrayPropertyValueErrors?: ArrayPropertyValueError[];
};
export type ErrorDetailsResult = ErrorDetailsResult2;
export type ErrorResult2 = ErrorResult;
export type ErrorResult3 = ErrorResult;
export type AccountIdDto = {
  AccountId: number;
};
export type UserIdDto = {
  UserId: number;
};
export type CreateAlarmSubscriptionDto = {
  User: UserIdDto;
  FeedSeverity?:
    | 'Information'
    | 'Trivial'
    | 'Minor'
    | 'Medium'
    | 'Major'
    | 'Critical';
  EmailSeverity?:
    | 'Information'
    | 'Trivial'
    | 'Minor'
    | 'Medium'
    | 'Major'
    | 'Critical';
};
export type AlarmTypeIdDto = {
  AlarmTypeId: number;
};
export type WriteAlarmInclusionDto = {
  AlarmType: AlarmTypeIdDto;
};
export type CreateAlarmGroupDto = {
  Name: string;
  Account: AccountIdDto;
  AlarmSubscriptions?: CreateAlarmSubscriptionDto[];
  AlarmInclusions?: WriteAlarmInclusionDto[];
};
export type ErrorResult4 = ErrorResult;
export type EditAlarmSubscriptionDto = {
  User?: UserIdDto;
  FeedSeverity?:
    | 'Information'
    | 'Trivial'
    | 'Minor'
    | 'Medium'
    | 'Major'
    | 'Critical';
  EmailSeverity?:
    | 'Information'
    | 'Trivial'
    | 'Minor'
    | 'Medium'
    | 'Major'
    | 'Critical';
};
export type EditAlarmGroupDto = {
  Name?: string;
  AlarmSubscriptions?: EditAlarmSubscriptionDto[];
  AlarmInclusions?: WriteAlarmInclusionDto[];
};
export type Associations = {
  Units?: number[];
  Buildings?: number[];
  JobSubscriptions?: number[];
  Sensors?: number[];
  Gateways?: number[];
  EnergyGroups?: number[];
  EnergyInitiatives?: number[];
  EnergyTreeNodes?: string[];
};
export type ReadAlarmDto = {
  AlarmId: number;
  AccountId: number;
  AlarmType?: string;
  DataFrom?: string;
  DataTo?: string;
  AlarmSubtype?: string;
  Severity:
    | 'Information'
    | 'Trivial'
    | 'Minor'
    | 'Medium'
    | 'Major'
    | 'Critical';
  Title?: string;
  Message?: string;
  MetaData?: string;
  Details?: string;
  State:
    | 'None'
    | 'Unresolved'
    | 'Reject'
    | 'Solved'
    | 'Reset'
    | 'AutoResolved'
    | 'FalseAlarm';
  Created: string;
  StateChanged?: string;
  StateHistory?: {
    [key: string]: string;
  };
  Associations?: Associations;
};
export type EditAlarmDto = {
  State?:
    | 'None'
    | 'Unresolved'
    | 'Reject'
    | 'Solved'
    | 'Reset'
    | 'AutoResolved'
    | 'FalseAlarm';
};
export type ReadAlarmTypeDto = {
  AlarmTypeId: number;
  Name: string;
  Description: string;
};
export type ReadAlarmTypeConfigurationDto = {
  UnitId?: number;
  UnitTypeInputId?: number;
  Key?: string;
  Type: 'Integer' | 'Datetime';
  AlarmTypeId: number;
  Value?: string;
  DataType?: string;
};
export const {
  useAlarmGroupsGetCollectionAsyncByqueryOptionsQuery,
  useLazyAlarmGroupsGetCollectionAsyncByqueryOptionsQuery,
  useAlarmGroupsPostBynewAlarmGroupMutation,
  useAlarmGroupsGetAsyncByidQuery,
  useLazyAlarmGroupsGetAsyncByidQuery,
  useAlarmGroupsDeleteAsyncByidMutation,
  useAlarmGroupsPatchAsyncByidalarmGroupMutation,
  useAlarmsGetCollectionAsyncByqueryOptionsQuery,
  useLazyAlarmsGetCollectionAsyncByqueryOptionsQuery,
  useAlarmsGetAsyncByidQuery,
  useLazyAlarmsGetAsyncByidQuery,
  useAlarmsPatchAsyncByidalarmMutation,
  useAlarmsGetFeedAsyncByqueryOptionsQuery,
  useLazyAlarmsGetFeedAsyncByqueryOptionsQuery,
  useAlarmTypesGetCollectionAsyncByqueryOptionsQuery,
  useLazyAlarmTypesGetCollectionAsyncByqueryOptionsQuery,
  useAlarmTypesGetAsyncByidQuery,
  useLazyAlarmTypesGetAsyncByidQuery,
  useUnitsResetAlarmByidalarmTypeIdMutation,
  useUnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeMutation,
  useUnitsGetAlarmConfigurationAsyncByidQuery,
  useLazyUnitsGetAlarmConfigurationAsyncByidQuery,
  useUnitsGetAllAlarmConfigurationsAsyncQuery,
  useLazyUnitsGetAllAlarmConfigurationsAsyncQuery,
} = injectedRtkApi;
